// Module
var code = "<template>\n    <li if.bind=\"customerId\" class=\"${isCurrent ? 'active' : ''}\">\n        <a href=\"/customers/${customerId}\">\n            ${ 'Layout_Navigation_CustomerInfo' | resource }\n            <span if.bind=\"isCurrent\" class=\"sr-only\" resource=\"Navigation_ScreenReader_Current\"></span>\n        </a>\n    </li>\n</template>\n";
// Exports
export default code;